import { StatusKey } from './formatState';

interface StatusValue {
  key: StatusKey;
  value: number;
  variation: number;
}

/**
 * Calcola i valori per p-2 ... p+2.
 * initialStatus diventa il baseline (es. p0=baseline).
 */
export function calculateHeartRateVariation(
  baseline: number,
  variationPercent: number, // es: 5 = 5%
  initialStatus: StatusKey = 'p0' // default p0
): StatusValue[] {
  const positions: StatusKey[] = ['p-2', 'p-1', 'p0', 'p1', 'p2'];
  const step = baseline * (variationPercent / 100);

  const refIndex = positions.findIndex(pos => pos === initialStatus);
  if (refIndex === -1) {
    throw new Error('initialStatus non valido');
  }

  return positions.map((key, index) => ({
    key,
    value: baseline + (index - refIndex) * step,
    variation: (index - refIndex) * variationPercent,
  }));
}
